var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ag-grid-vue',{staticClass:"ag-theme-alpine table-style",attrs:{"gridOptions":_vm.gridOptions,"columnDefs":_vm.columnDefs,"rowData":_vm.rowData,"suppressDragLeaveHidesColumns":"","suppressMovableColumns":"","checkboxSelection":false},on:{"grid-ready":_vm.onGridReady,"first-data-rendered":_vm.onDataRendered}})
}
var staticRenderFns = []

export { render, staticRenderFns }